<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Precipitaciones de Lote</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div v-if="plot" class="row">
        <div v-if="isEditable" class="col-md-5 col-sm-12">
          <plots-rain-form ref="plotsRainForm" :server-errors="serverErrors" @save="saveNewPlotsRain" />
        </div>
        <div class="col-md-7 col-sm-12">
          <plots-rain-table
            v-if="plot"
            ref="plotsRainTable"
            :rain-measures="plot.rainMeasures"
            :can-delete="isEditable"
            @delete="deleteRain"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import PlotsRainForm from './Form.vue';
import PlotsRainTable from './Table.vue';
import swal from 'sweetalert2';

export default {
  components: {
    RouteBreadCrumb,
    PlotsRainForm,
    PlotsRainTable,
  },

  data() {
    return {
      plot: null,
      serverErrors: [],
      plotsId: '',
    };
  },

  computed: {
    isEditable() {
      return Boolean(
        this.plot &&
          ((this.$can('store', 'rain_measures') && !this.plot.isShare) ||
            (this.plot.isShare && this.plot.write && this.$can('store', 'rain_measures')))
      );
    },
  },

  mounted() {
    this.plotsId = this.$route.params.id;
    this.fetchPlot();
  },

  methods: {
    fetchPlot() {
      this.$services
        .resource('plots')
        .show(this.plotsId, { include: ['rain_measures'] })
        .then((res) => res.data.data)
        .then((plot) => {
          this.plot = plot;
        });
    },

    saveNewPlotsRain(plotsRain) {
      this.$services
        .resource('plot_rains')
        .setPlot(this.plotsId)
        .create(plotsRain)
        .then((res) => res.data.data)
        .then((data) => {
          this.afterSave(data);
          swal({
            title: 'Listo!',
            text: 'La precipitación fue creada.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          });
        })
        .catch((errors) => {
          this.serverErrors = errors;
        });
    },

    afterSave(newPlotsRain) {
      this.plot.rainMeasures.push(newPlotsRain);
      this.plot.rainMeasures.sort(function (a, b) {
        return new Date(b.date) - new Date(a.date);
      });
      this.$refs.plotsRainForm.cleanForm();
    },

    deleteRain(rainId) {
      this.$services
        .resource('plot_rains')
        .setPlot(this.plotsId)
        .delete(rainId)
        .then(() => {
          swal({
            title: 'Eliminada!',
            text: `La precipitación ha sido eliminada con éxito.`,
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          });
          this.fetchPlot();
        });
    },
  },
};
</script>
